import React from "react";
import { Button, Input, Label } from "reactstrap";

export type TaskSummaryFilter = "all" | "pending" | "completed";

type Props = {
  totalTasks: number;
  completedCount: number;
  pendingCount: number;
  filter: TaskSummaryFilter;
  setFilter: (next: TaskSummaryFilter) => void;
  query: string;
  setQuery: (value: string) => void;
};

export default function TasksSummaryFilters({
  totalTasks,
  completedCount,
  pendingCount,
  filter,
  setFilter,
  query,
  setQuery,
}: Props) {
  return (
    <React.Fragment>
      <div className="d-flex flex-wrap gap-2 mb-3">
        <span className="badge bg-light text-body border">
          Total: {totalTasks}
        </span>
        <span className="badge bg-success-subtle text-success">
          Completed: {completedCount}
        </span>
        <span className="badge bg-warning-subtle text-warning">
          Pending: {pendingCount}
        </span>
      </div>

      {totalTasks > 0 ? (
        <div className="border rounded p-3 mb-3">
          <div
            className="d-flex flex-wrap gap-2 mb-2"
            role="group"
            aria-label="Filter tasks by status"
          >
            <Button
              type="button"
              size="sm"
              color={filter === "all" ? "primary" : "light"}
              onClick={() => setFilter("all")}
            >
              All
            </Button>
            <Button
              type="button"
              size="sm"
              color={filter === "pending" ? "warning" : "light"}
              onClick={() => setFilter("pending")}
            >
              Pending
            </Button>
            <Button
              type="button"
              size="sm"
              color={filter === "completed" ? "success" : "light"}
              onClick={() => setFilter("completed")}
            >
              Completed
            </Button>
          </div>
          <Label
            className="form-label small text-muted mb-1"
            htmlFor="work-order-task-search"
          >
            Search
          </Label>
          <Input
            id="work-order-task-search"
            type="text"
            bsSize="sm"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search tasks by title or description..."
          />
        </div>
      ) : null}
    </React.Fragment>
  );
}
